import React from 'react';
import issue from '../../static/images/library/issue.png';
import returnBook from '../../static/images/library/return.png';
import reniew from '../../static/images/library/reniew.png';
import activeRegister from '../../static/images/library/activeRegister.png';
import addBook from '../../static/images/library/addBook.png';
import ddc from '../../static/images/library/ddc.png';
import exportPng from '../../static/images/library/export.png';
import footprint from '../../static/images/library/footprint.png';
import master from '../../static/images/library/master.png';
import members from '../../static/images/library/members.png';
import movement from '../../static/images/library/movement.png';
import opac from '../../static/images/library/opac.png';
import sb from '../../static/images/library/sb.png';
import applicationForm from '../../static/images/accademics/applicationForm.png';
import suscribe from '../../static/images/library/suscribe.png';
import lost from '../../static/images/library/lost.png';
import labels from '../../static/images/library/labels.png';
import holyday from '../../static/images/library/holyday.png';
import subsidiaryRegister from '../../static/images/report/subsidiaryRegister.png';
import hierarchy from '../../static/images/report/hierarchy.png';
import accounts from '../../static/images/report/accounts.png';
import dues from '../../static/images/report/dues.png';
import collectedFee from '../../static/images/report/collectedFee.png';
import dayBook from '../../static/images/report/dayBook.png';
import cashBook from '../../static/images/report/cashBook.png';
import scholarship from '../../static/images/report/scholarship.png';
import electoralRoll from '../../static/images/report/electoralRoll.png';
import transferCertificate from '../../static/images/report/transferCertificate.png';
import statistics from '../../static/images/report/statistics.png';
import attendanceRegister from '../../static/images/accademics/attendanceRegister.png';
import rolleView from '../../static/images/report/rolleView.png';
import file1 from '../../static/images/naac/File 1.png';
import file2 from '../../static/images/naac/File 2.png';
import file3 from '../../static/images/naac/File 3.png';
import file4 from '../../static/images/naac/File 4.png';
import file5 from '../../static/images/naac/File 5.png';
import file6 from '../../static/images/naac/File 6.png';
import file7 from '../../static/images/naac/File 7.png';
import atts from '../../static/images/iqac/atts.png';
import feedback from '../../static/images/iqac/feedBack.png';
import allocation from '../../static/images/iqac/allocation.png';
import master2 from '../../static/images/iqac/master.png';
import verified from '../../static/images/iqac/verified.png';
import pending from '../../static/images/iqac/pending.png';
import student from '../../static/images/iqac/student.png';
import staff from '../../static/images/iqac/staff.png';
import { closeAnimation } from '../../NecttosComp/Layout/Layout';
import { OpenCourse } from '../../CollegeApp/Academics/OpenCourse/OpenCourse';
import { TeacherProfile } from '../../CollegeApp/IQAC/TeacherProfile';
import { RoleManagements } from '../../CollegeApp/Settings/RoleManagements';
import { Attendance } from '../../CollegeApp/Academics/StudentIntividualAttendance';
import { AttendanceMonthly } from '../../CollegeApp/Academics/AttendanceMonthly';
import FeeStructure from '../../CollegeApp/Accounts/FeeStructure';
import { IssueBook } from '../../CollegeApp/Library/IssueBook';
import ProFacMonitor from '../../CollegeApp/Academics/ProFacMonitor';
import DeleteUser from '../../CollegeApp/Office/DeleteUser';
import InvoiceManagement from '../../CollegeApp/Library/InvoiceManagement';
import LoastRegister from '../../CollegeApp/Library/LostRegister';
import HungryFreeCampus from '../../CollegeApp/Office/HungryFreeCampus';
import { RenewBook } from '../../CollegeApp/Library/RenewBook';
import { ActiveRegister } from '../../CollegeApp/Library/ActiveRegister';
import { ReturnBook } from '../../CollegeApp/Library/ReturnBook';
import AddBook from '../../CollegeApp/Library/AddBook';
import { Opac } from '../../CollegeApp/Library/Opac';
import { NaacDataCollection } from '../../CollegeApp/NaaC/NaacDataCollection';
import ModalWrapper from '../../components/ModalWrapper';
import { Master } from '../../CollegeApp/Library/Master';
import { Members } from '../../CollegeApp/Library/Members';
import { Movements } from '../../CollegeApp/Library/Movement';
import { Labels } from '../../CollegeApp/Library/Labels';
import { DDCSubjects } from '../../CollegeApp/Library/DDCSubjects';
import { Holidays } from '../../CollegeApp/Library/Holidays';
import { MainAccounts } from '../../CollegeApp/Accounts/MainAccount';
import { CollectionReports } from '../../CollegeApp/Accounts/CollectionReports';
import { DuesReport } from '../../CollegeApp/Accounts/DuesReport';
import { Scholarship } from '../../CollegeApp/Accounts/Scholarship';
import { NameSlip } from '../../CollegeApp/Office/NameSlip';
import { FootPrint } from '../../CollegeApp/Library/FootPrint';
import { Statistics } from '../../CollegeApp/Office/Statistics';
import { LibraryStatisticsExport } from '../../CollegeApp/Library/LibraryStatisticsExport';
import { RollView } from '../../CollegeApp/Office/RollView';
import FeeBilling from '../../CollegeApp/Accounts/FeesBilling';
import { StrengthDetails } from '../../CollegeApp/Office/StrengthDetails';
import { Periodicals } from '../../CollegeApp/Library/Periodicals';
import { PeriodicalsEntry } from '../../CollegeApp/Library/PeriodicalsEntry';
import { IncomeExpenditure } from '../../CollegeApp/Accounts/RecieptPayment';
import { TransferSertificateCC } from '../../CollegeApp/Office/TransferSertificateCC';
import { SubAccounts } from '../../CollegeApp/Accounts/SubAccounts';
import InstanceFeeCollection from '../../CollegeApp/Accounts/InstanceFeeCollection/index';
import { EResources } from '../../CollegeApp/Library/EResources';
import { MasterTimeTables } from '../../CollegeApp/Office/MasterTimeTables';
import { EarnLeaveCalculator } from '../../CollegeApp/Accounts/EarnLeaveCalculator';
import { FineRegister } from '../../CollegeApp/Library/FineRegister';
import { Internal } from '../../CollegeApp/Academics/Internal';
import { APC } from '../../CollegeApp/Academics/Apc';
import { CatogoryListData } from '../../CollegeApp/Office/CategoryList';
import { FDCB } from '../../CollegeApp/Accounts/FDCB';
import { CashBankReports } from '../../CollegeApp/Accounts/CashBankReports';
import { IdCardPrinting } from '../../CollegeApp/Office/IDCardPrinting';
import { Numbers } from '../../CollegeApp/Accounts/Numbers';
import { CreateAccount } from '../../CollegeApp/Admission/CreateAccount';
import { DepartmentVery } from '../../CollegeApp/Admission/DepartmentVery';
import Principal from '../../CollegeApp/Admission/Principal';
import Office from '../../CollegeApp/Admission/Office';
import Fees from '../../CollegeApp/Admission/Fees';
import University from '../../CollegeApp/Admission/University';
import PTA from '../../CollegeApp/Admission/PTA';
import DashBoard from '../../CollegeApp/Admission/AdmissionDashBoard';
import Controller from '../../CollegeApp/Admission/AdmissionController';
import Splitups from '../../CollegeApp/Admission/Splitups';
import EGrantz from '../../CollegeApp/Admission/EGrantz';
import EPosMirgration from '../../CollegeApp/Admission/EPosMirgration';
import EGrantManagement from '../../CollegeApp/Admission/EGrantManagement';
import { RankList } from '../../CollegeApp/Academics/RankList';
import ElectoralRoll from '../../CollegeApp/Office/ElectoralRoll';
import { SubjectWiseAttendance } from '../../CollegeApp/Academics/SubjectWiseAttendance';
import { ClassWiseAttendance } from '../../CollegeApp/Academics/ClassWiseAttendance';
import { BookRecomentation } from '../../CollegeApp/Library/BookRecomentation';
import SubjectBank from '../../CollegeApp/Academics/SubjectBank';
import C2_1 from '../../CollegeApp/NaaC/C2_1';
import C2_2 from '../../CollegeApp/NaaC/C2_2';
import C2_3 from '../../CollegeApp/NaaC/C2_3';
import C2_4 from '../../CollegeApp/NaaC/C2_4';
import C2_5 from '../../CollegeApp/NaaC/C2_5';
import C2_6 from '../../CollegeApp/NaaC/C2_6';
import C2_7 from '../../CollegeApp/NaaC/C2_7';
import C2_8 from '../../CollegeApp/NaaC/C2_8';
import C2_9 from '../../CollegeApp/NaaC/C2_9';
import C2_10 from '../../CollegeApp/NaaC/C2_10';
import C3_1a from '../../CollegeApp/NaaC/C3_1a';
import C3_1b from '../../CollegeApp/NaaC/C3_1b';
import C3_1_1 from '../../CollegeApp/NaaC/C3_1_1';
import C3_2_2 from '../../CollegeApp/NaaC/C3_2_2';
import C3_3_2 from '../../CollegeApp/NaaC/C3_3_2';
import C3_3_3 from '../../CollegeApp/NaaC/C3_3_3';
import C3_4_2 from '../../CollegeApp/NaaC/C3_4_2';
import C3_4_3 from '../../CollegeApp/NaaC/C3_4_3';
import C3_5_1 from '../../CollegeApp/NaaC/C3_5_1';
import C3_5_2 from '../../CollegeApp/NaaC/C3_5_2';
import AddUserPage from '../../CollegeApp/Office/AddUserPage';
import DepartmentMaster from '../../CollegeApp/Academics/DepartmentMaster';
import NIFR from '../../CollegeApp/NIRF/NIFR/NIFR';
import { BankCash } from '../../CollegeApp/Accounts/BankCash';
import BEDStudent from '../../CollegeApp/Academics/BEDStudent';
import C2 from '../../CollegeApp/NaaC/C2';
import AccademicHoliday from '../../CollegeApp/Academics/AccademicHoliday';
import MentorMentee from '../../CollegeApp/Academics/MentorMentee';
import MasterStockRegister from './MasterStockRegister';
import QuestionBankCreator from '../../CollegeApp/QuestionPaperManagement/QuestionBankCreator';
import QuestionBankCreatorVerification from '../../CollegeApp/QuestionPaperManagement/QuestionBankCreatorVerification';
import QuestionPaper from '../../CollegeApp/QuestionPaperManagement/QuestionPaper';
import QuetionBankManager from '../../CollegeApp/QuestionPaperManagement/QuetionBankManager';
import C1 from '../../CollegeApp/NaaC/C1';
import C3 from '../../CollegeApp/NaaC/C3';
import { Analytics } from '../../CollegeApp/Office/Analystics';
import ApplicationRecieved from '../../CollegeApp/Admission/CompletedApplications';
import EnquriyForm from '../../CollegeApp/Admission/EnquiriesReceived';
import InsertData from '../../CollegeApp/Office/InsertData';
import UpdateData from '../../CollegeApp/Office/UpdateData';
import AllotmentList from '../../CollegeApp/Admission/AllotmentList';
import RankListRules from '../../CollegeApp/Admission/RankListRules';
import RecheckPayments from '../../CollegeApp/Accounts/RecheckPayments';
import PyementWaitingSubmition from '../../CollegeApp/Admission/PendingApplicationswithFeesPaid';
import CordinatorShipAdmin from '../../CollegeApp/EventsManagment/CordinatorShipAdmin';
import CordinatorShipForm from '../../CollegeApp/EventsManagment/CordinatorShipForm';
import ClubCellsAccounts from '../../CollegeApp/EventsManagment/ClubCellsAccounts';
import CourseManagement from '../../CollegeApp/Office/CourseManagement';
import ApplicationStarted from '../../CollegeApp/Admission/ApplicationsInitiated';
import CourseWiseRankList from '../../CollegeApp/Admission/CourseWiseRankList';
import SeatReservationDetails from '../../CollegeApp/Admission/SeatReservationDetails';
import DueRegister from '../../CollegeApp/Library/DueRegister';
import PriorityChanger from '../../CollegeApp/Admission/PriorityChanger';
import Certificate from '../../CollegeApp/Office/Certificate';
import PhotoVerification from '../../CollegeApp/Admission/PhotoVerification';
import AdmissionRegister3 from '../../CollegeApp/Admission/AdmissionRegister3';
import ExamInit from '../../CollegeApp/Examination/ExamInit';
import ExamNotification from '../../CollegeApp/Examination/Notification';
import Condonation from '../../CollegeApp/Examination/Condonation';
import ElectiveChanger from '../../CollegeApp/Academics/ElectiveChanger';
import AccountActiveFirebase from '../../CollegeApp/Accounts/AccountActiveFirebase';
import PhotoDownloader from '../../CollegeApp/Office/PhotoDownloader';
import Numbering from '../../CollegeApp/Office/Numbering';
import AnswerSheetBundleManagement from '../../CollegeApp/Examination/AnswerSheetBundleManagement';
import ExamRegistration from '../../CollegeApp/Examination/ExamRegistration';
import TimeTableManagement from '../../CollegeApp/Examination/TimeTableManagement';
import SeatingPlan from '../../CollegeApp/Examination/SeatingPlan';
import RoomArrangement from '../../CollegeApp/Examination/RoomArrangement';
import InvigilationManagement from '../../CollegeApp/Examination/InvigilationManagement';
import HalltiketDistribution from '../../CollegeApp/Examination/HalltiketDistribution';
import RoomDocuments from '../../CollegeApp/Examination/RoomDocuments';
import BarcodeDownload from '../../CollegeApp/Examination/BarcodeDownload';
import ValuationManagement from '../../CollegeApp/Examination/ValuationManagement';
import ResultPublication from '../../CollegeApp/Examination/ResultPublication';
import FalseNumbering from '../../CollegeApp/Examination/FalseNumbering';
import StudentResponds from '../../CollegeApp/FYUGP/StudentResponds';
import SubjectRegistry from '../../CollegeApp/FYUGP/SubjectRegistry';
import RealTimeAllotment from '../../CollegeApp/FYUGP/RealTimeAllotment';
import RealTimeRanking from '../../CollegeApp/FYUGP/RealTimeRanking';
import DataLoader from '../../CollegeApp/Office/DataLoader';
import StudentsAllotmentClassWise from '../../CollegeApp/FYUGP/StudentsAllotmentClassWise';
import FYUGPDashBoard from '../../CollegeApp/FYUGP/FYUGPDashBoard';
import ConfirmedClassWiseAllotment from '../../CollegeApp/FYUGP/ConfirmedClassWiseAllotment';
import ConfirmedCourseWiseAllotment from '../../CollegeApp/FYUGP/ConfirmedCourseWiseAllotment';
import BulkFeeData from '../../CollegeApp/Academics/BulkFeeData';
import { RecieptsPayments } from '../../CollegeApp/Accounts/RecieptPaymentNew';
import { SubsidiaryRegisterYearWise } from '../../CollegeApp/Accounts/SubsidiaryRegisterYearWise';
import { CollectioReportsNew } from '../../CollegeApp/Accounts/CollectioReportsNew';
import SubjectAllocationAuto from '../../CollegeApp/FYUGP/SubjectAllocationAuto';
import SportAdmission from '../../CollegeApp/FYUGP/SportAdmission';
import UniversityUploadList from '../../CollegeApp/FYUGP/UniversityUploadList';
import TagOrder from '../../CollegeApp/Office/TagOrder';
import { AttendanceCorrectionBulk } from '../../CollegeApp/Office/AttendanceCorrectionBulk';
import { NewNameSlip } from '../../CollegeApp/Office/NameSlip/NameSlip';
import NewTransferCertificate from '../../CollegeApp/Office/NewTransferCertificate';
import DataManagementSystem from '../../CollegeApp/Admission/DataManagementSystem';
import NAAC2024 from '../../CollegeApp/NaaC/NAAC2024';
import { FeeConcession } from '../../CollegeApp/Accounts/FeeConcession';
import { InternalAssessment } from '../../CollegeApp/Office/InternalAssessment';
import { Releaving } from '../../CollegeApp/Office/Releaving';
import NewProfile from '../NewProfile';
import SemesterWiseStudentData from '../../CollegeApp/Academics/SemesterWiseStudentData';
import { LeaveReports } from '../../CollegeApp/Office/LeaveReports';
import { NEWDCB } from '../../CollegeApp/Accounts/newDCB';
import BasicDataVerification from '../../CollegeApp/Accounts/BasicDataVerification';
import NewRolloutManagement from '../../CollegeApp/Office/NewRolloutManagement';
import TimeShedulePage from '../../CollegeApp/Academics/TimeShedulePage';
import SupperVision from '../../CollegeApp/Academics/supperVission';
import DashPage from '../../CollegeApp/Office/MasterTable';
import { C1_1 } from '../../CollegeApp/NaaC/C1_1';
import { DFCR } from '../../CollegeApp/Accounts/DFCR';
import MenteePDF from '../../CollegeApp/Election/Mentee';
import { PostElection } from '../../CollegeApp/Election/SubAccounts';
import { DayBook2 } from '../../CollegeApp/Accounts/DayBook';
import { CollectionReportsAMC } from '../../CollegeApp/Accounts/CollectionReportsAMC';
import NecttosInvoiceManagement from '../../CollegeApp/Accounts/NecttosInvoiceManagement';
import HierarchyManagemant from '../../CollegeApp/DDFS/HierarchyManagement';
import TemplateManagement from '../../CollegeApp/DDFS/TemplateManagement';
import DDFSDash from '../../CollegeApp/DDFS/DDFSDash';
import { CashBook } from '../../CollegeApp/Accounts/CashBook';
import DataBank from '../../CollegeApp/Office/DataBank.jsx';
import SettingsPage from '../../NecttosComp/SettingsPage';
import ActivityMonitoring from '../../CollegeApp/Office/ActivityMonitoring';
import CollegeVerification from '../Office/CollegeVerification';
import BugHandler from '../Office/BugHandler';
import TaskTracker from '../Office/TaskTracker';
import CareerView from '../Office/CareerView';

import { FeedBackDashBoard } from '../../CollegeApp/IQAC/FeedBackReports/FeedBackDashBoard';
import Documentation from '../Office/Documentation';
import AdmissionProcessingDashBoard from '../../CollegeApp/AdmissionProcess/AdmissionControlCenter';
import { TransferCertificate } from '../../CollegeApp/Office/TransferCertificate';
import FeatureManagement from '../../CollegeApp/Settings/FeatureControl';
import { StudentProfile } from '../../CollegeApp/IQAC/StudentProfile';
import { StaffProfile } from '../../CollegeApp/IQAC/StaffProfile';
import FormsManagement from '../../CollegeApp/Office/FormsManagement';
import Circular from '../Office/Circular';
import AdmissionControlCenter from '../../CollegeApp/AdmissionProcess/AdmissionControlCenter';
import Busconcession from '../../CollegeApp/Busconcession';
import BackUp from '../../CollegeApp/BackUp/BackUp';
import ConfirmedBatchWiseAllotment from '../../CollegeApp/FYUGP/ConfirmedBatchWiseAllotment';
import WebsiteControlCenter from '../../WebControlCenter/WebsiteControlCenter';
import LearningManagementSystem from '../../LearningManagementSystem/LearningManagementSystem';

export const getMenuList = (collegeId, verificationWindows, selectedCollege, roles, needFilter = true) => {
	let MENU_ITEMS = [
		//Necttos
		{
			classification: 'Office',
			keyData: 'collegeVerifcation',
			title: 'College Verification',
			img: statistics,
			instituitionType: ['necttos'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},

		{
			classification: 'Office',
			keyData: 'bugHandler',
			title: 'Bug Handler',
			img: subsidiaryRegister,
			instituitionType: ['necttos'],
			allowedUsers: ['admin', 'staff', 'teacher', 'principal'],
		},

		{
			classification: 'Office',
			keyData: 'TaskTracker',
			title: 'Task Tracker',
			img: dayBook,
			instituitionType: ['necttos'],
			allowedUsers: ['admin', 'staff', 'teacher', 'principal'],
		},

		{
			classification: 'Office',
			keyData: 'CareerView',
			title: 'Career View',
			img: members,
			instituitionType: ['necttos'],
			allowedUsers: ['admin', 'staff', 'teacher', 'principal'],
		},

		{
			classification: 'Office',
			keyData: 'Documentation',
			title: 'Documentation',
			img: rolleView,
			instituitionType: ['necttos'],
			allowedUsers: ['admin', 'staff', 'teacher', 'principal'],
		},

		{
			classification: 'Office',
			keyData: 'Circular',
			title: 'Circular',
			img: applicationForm,
			instituitionType: ['necttos'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},

		//Office
		{
			classification: 'Office',
			keyData: 'backup',
			title: 'Backup Control',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'office', 'principal', 'teacher'],
		},

		{
			classification: 'Office',
			keyData: 'rollView',
			title: 'Roll View',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'office', 'principal', 'teacher'],
		},
		{
			classification: 'Office',
			keyData: 'dataLoader',
			title: 'Data Loader & Checker',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'office', 'principal', 'teacher'],
		},

		{
			classification: 'Office',
			keyData: 'nameSlip',
			title: 'Name Slip',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'superintend', 'office', 'teacher', 'principal'],
		},
		{
			classification: 'Office',
			keyData: 'newNameSlip',
			title: 'New Name Slip',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'superintend', 'office', 'teacher', 'principal'],
		},
		{
			classification: 'Office',
			keyData: 'statistics',
			title: 'Statistics 2.0',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office', 'principal', 'teacher', 'library'],
		},

		{
			classification: 'Office',
			keyData: 'internalAssessment',
			title: 'Internal Assessment',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office', 'principal', 'teacher', 'library'],
		},
		{
			classification: 'Office',
			keyData: 'newRolloutManagement',
			title: 'Rollout Management',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office', 'principal', 'teacher', 'library'],
		},
		{
			classification: 'Office',
			keyData: 'leaveReports',
			title: 'Leave Reports',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office', 'principal', 'teacher', 'library'],
		},

		{
			classification: 'Office',
			keyData: 'releaving',
			title: 'Releaving',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office', 'principal', 'teacher', 'library'],
		},

		{
			classification: 'Office',
			keyData: 'tcCc',
			title: 'Transfer Certificate',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office', 'principal'],
		},
		{
			classification: 'Office',
			keyData: 'newTransferCertificate',
			title: 'New Transfer Certificate',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office', 'principal'],
		},
		{
			classification: 'Office',
			keyData: 'TransferCertificate',
			title: 'Transfer Certificate 2.0',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office', 'principal'],
		},
		{
			classification: 'Office',
			keyData: 'catogoryList',
			title: 'CatogoryList',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'attendance', 'office', 'superintend', 'principal'],
		},
		{
			classification: 'Office',
			keyData: 'strengthDetails',
			title: 'Strength Details',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'attendance', 'office', 'superintend', 'principal'],
		},
		{
			classification: 'Office',
			keyData: 'earnLeaveCalculator',
			title: 'Earn Leave Calculator',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Office',
			keyData: 'masterTable',
			title: 'Master Table',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'cashier', 'office'],
		},
		{
			classification: 'Office',
			keyData: 'masterTable2',
			title: 'Master Table 2',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'cashier', 'office'],
		},
		{
			classification: 'Office',
			keyData: 'supperVission',
			title: 'Super Vision',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal'],
		},
		{
			classification: 'Office',
			keyData: 'addUser',
			title: 'Add New',
			instituitionType: ['selfCollege', 'necttos', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher'],
		},
		{
			classification: 'Office',
			keyData: 'deleteUser',
			title: 'Delete User',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal'],
		},
		{
			classification: 'Office',
			keyData: 'tagOrder',
			title: 'Tag Order',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'office'],
		},
		{
			classification: 'Office',
			keyData: 'idCardPrinting',
			title: 'ID Card Printing',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'headAccountant', 'cashier', 'superintend', 'principal', 'office', 'teacher'],
		},
		{
			classification: 'Office',
			keyData: 'hungerFreeCampus',
			title: 'Hunger Free Campus',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['principal', 'teacher'],
		},
		{
			classification: 'Office',
			keyData: 'insertUsers',
			title: 'Insert Users',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['principal', 'teacher', 'office'],
		},
		{
			classification: 'Office',
			keyData: 'attendanceCorrectionBulk',
			title: 'Attendance Correction Bulk',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['principal', 'office'],
		},

		{
			classification: 'Office',
			keyData: 'updateUsers',
			title: 'Update Users',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['principal', 'teacher', 'office'],
		},
		{
			classification: 'Office',
			keyData: 'courseManagement',
			title: 'Course Management',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['principal', 'teacher', 'office'],
		},
		{
			sortKey: '008',
			classification: 'Admission',
			title: 'Admission Control Center',
			keyData: 'admissionControlCenter',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'staff'],
		},
			{
			sortKey: '408',
			classification: 'Admission',
			title: 'Busconcession card',
			keyData: 'Busconcession',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'staff'],
		},
		{
			sortKey: '0044',
			classification: 'Office',
			keyData: 'certificate',
			title: 'Certificate',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal', 'teacher', 'Office'],
		},
		{
			classification: 'Office',
			keyData: 'accountActiveFirebase',
			title: 'Account Active Firebase',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'clerk', 'teacher', 'Office'],
		},
		{
			classification: 'Office',
			keyData: 'websiteControlCenter',
			title: 'Website Control Center',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal'],
		},				
		{
			classification: 'Office',
			keyData: 'LearningManagementSystem',
			title: 'Learning Management System',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal'],
		},


		{
			classification: 'Office',
			keyData: 'photoDownload',
			title: 'Photo Download',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office'],
		},
		{
			classification: 'Office',
			keyData: 'rollNumberDistributer',
			title: 'Roll Number Distributer',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office'],
		},

		...(verificationWindows?.departmentVerfication
			? [
					{
						sortKey: '007',
						classification: 'Admission',
						keyData: 'departmentVerification',
						title: 'Department Verification',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'departmentVerfication', 'superintend', 'principal', 'teacher'],
					},
			  ]
			: []),
		...(verificationWindows?.nodalVerification
			? [
					{
						sortKey: '008',
						classification: 'Admission',
						keyData: 'nodalVerification',
						title: collegeId === 'COL-D6DE25F23FF5-40A6-9E76-4A2AF63D1B5F' ? 'Department Senior Verification' : 'Nodal Verification',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'nodalVerification', 'teacher', 'headAccountant', 'principal', 'nodal'],
					},
			  ]
			: []),
		...(verificationWindows?.collegeFundCollection
			? [
					{
						sortKey: '010',
						classification: 'Admission',
						keyData: 'ptaVerification',
						title: 'PTA Collection',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'collegeFundCollection', 'headAccountant', 'principal', 'office', 'nodal'],
					},
			  ]
			: []),
		...(verificationWindows?.principalVerification
			? [
					{
						sortKey: '011',
						classification: 'Admission',
						keyData: 'principalVerification',
						title: 'Principal Verification',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'principalVerification', 'superintend', 'principal', 'office', 'nodal'],
					},
			  ]
			: []),
		...(verificationWindows?.officeVerification
			? [
					{
						sortKey: '012',
						classification: 'Admission',
						keyData: 'officeVerification',
						title: 'Office Verification',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'officeVerification', 'headAccountant', 'principal', 'clerk'],
					},
			  ]
			: []),
		...(verificationWindows?.govermentFeeCollection
			? [
					{
						sortKey: '014',
						classification: 'Admission',
						keyData: 'feesVerification',
						title: 'Fees Collection',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'headAccountant', 'govermentFeeCollection', 'cashier', 'principal'],
					},
			  ]
			: []),
		...(verificationWindows?.universityUploads
			? [
					{
						sortKey: '015',
						classification: 'Admission',
						keyData: 'universityUploading',
						title: 'University Upload',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'principal', 'universityUploads', 'teacher', 'nodal'],
					},
			  ]
			: []),
		...(verificationWindows?.grandVerification
			? [
					{
						sortKey: '013',
						classification: 'Admission',
						keyData: 'grandVerification',
						title: 'E-Grantz Verification',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'grandVerification', 'cashier'],
					},
			  ]
			: []),
		...(verificationWindows?.enquiriesReceived
			? [
					{
						sortKey: '001',
						classification: 'Admission',
						keyData: 'enquryForm',
						title: 'Enquiries Received',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal', 'teacher', 'staff'],
					},
			  ]
			: []),
		...(verificationWindows?.applicationsInitiated
			? [
					{
						sortKey: '002',
						classification: 'Admission',
						keyData: 'applicationStated',
						title: 'Applications Initiated',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal', 'teacher', 'staff'],
					},
			  ]
			: []),
		...(verificationWindows?.pendingApplicationswithFeesPaid
			? [
					{
						sortKey: '003',
						classification: 'Admission',
						keyData: 'pyementWaitingSubmition',
						title: 'Pending Applications with Fees Paid',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal', 'teacher', 'staff'],
					},
			  ]
			: []),
		...(verificationWindows?.completedApplications
			? [
					{
						sortKey: '004',
						classification: 'Admission',
						keyData: 'applicationRecieved',
						title: 'Completed Applications',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal', 'teacher', 'staff'],
					},
			  ]
			: []),
		...(verificationWindows?.courseWiseRankList
			? [
					{
						sortKey: '005',
						classification: 'Admission',
						keyData: 'indexMarkListed',
						title: 'Course-Wise Ranking',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal', 'teacher'],
					},
			  ]
			: []),
		...(verificationWindows?.seatReservationDetails
			? [
					{
						sortKey: '005',
						classification: 'Admission',
						keyData: 'seatReservation',
						title: 'Seat Reservation Details',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal', 'teacher'],
					},
			  ]
			: []),
		...(verificationWindows?.officeVerification
			? [
					{
						sortKey: '0044',
						classification: 'Admission',
						keyData: 'priorityChanger',
						title: 'Priority Changer',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal', 'teacher'],
					},
			  ]
			: []),
		...(verificationWindows?.allotmentList
			? [
					{
						sortKey: '006',
						classification: 'Admission',
						keyData: 'rankListAuto',
						title: 'Real-Time Allotment',
						img: applicationForm,
						instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
						allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal', 'teacher', 'staff'],
					},
			  ]
			: []),

		{
			classification: 'Admission',
			keyData: 'photoVerification',
			title: 'Photo Verification',
			img: applicationForm,
			instituitionType: ['aidedCollege', 'selfCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'staff'],
		},
		{
			classification: 'Admission',
			keyData: 'rankList',
			title: 'Rank List PDF',
			img: applicationForm,
			instituitionType: ['aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'staff'],
		},
		{
			classification: 'Admission',
			keyData: 'tcCc',
			title: 'Transfer Certificate',
			img: transferCertificate,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office', 'principal'],
		},
		{
			classification: 'Admission',
			keyData: 'controller',
			title: 'Controller',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'clerk', 'principal', 'nodal'],
		},
		{
			classification: 'Admission',
			keyData: 'dashBoard',
			title: 'Dash Board',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal'],
		},
		{
			classification: 'Admission',
			keyData: 'splitups',
			title: 'Splitups',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal'],
		},
		{
			classification: 'Admission',
			keyData: 'admissionRegister',
			title: 'Admission Register',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'teacher', 'nodal'],
		},
		{
			classification: 'Admission',
			keyData: 'epos',
			title: 'E-POS Migration',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal'],
		},
		{
			classification: 'Admission',
			keyData: 'rankListRules',
			title: 'Rank List Rules',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'nodal', 'teacher', 'staff'],
		},
		{
			classification: 'Admission',
			keyData: 'dataManagementSystem',
			title: 'Data Management System',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'teacher', 'nodal'],
		},
		{
			classification: 'Adminitration',
			keyData: 'hierarchy',
			title: 'Hierarchy',
			img: hierarchy,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'superintend'],
		},
		{
			classification: 'Adminitration',
			keyData: 'postBulkJournals',
			title: 'Post Bulk Journals',
			img: subsidiaryRegister,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin'],
		},
		{
			classification: 'Adminitration',
			keyData: 'workingFile',
			title: 'Working File',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin'],
		},
		{
			classification: 'Adminitration',
			keyData: 'profile',
			title: 'Profile',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin'],
		},
		{
			classification: 'Adminitration',
			keyData: 'newProfile',
			title: 'Profile',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin'],
		},

		{
			classification: 'Accounts',
			keyData: 'feeStructure',
			title: 'Fee Structure',
			img: subsidiaryRegister,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'headAccountant', 'cashier', 'superintend', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'instanceFeeCollection',
			title: 'Fee Demand',
			img: subsidiaryRegister,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'headAccountant', 'cashier', 'superintend', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'feesBilling',
			title: 'Fee Receipt',
			img: subsidiaryRegister,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'headAccountant', 'cashier', 'superintend', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'eGrantManagement',
			title: 'E-Grantz Management',
			img: applicationForm,
			instituitionType: ['aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintend', 'principal', 'clerk', 'grandVerification', 'cashier'],
		},
		{
			classification: 'Accounts',
			keyData: 'newDFCR',
			title: 'DFCR',
			img: subsidiaryRegister,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'headAccountant', 'cashier', 'superintend', 'principal'],
		},

		{
			classification: 'Accounts',
			keyData: 'dayBook',
			title: 'Day Books',
			img: dayBook,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'collectionReports',
			title: 'Collection Reports',
			img: collectedFee,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'collectionReportsAMC',
			title: 'Collection Reports old',
			img: collectedFee,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'collectioReportsNew',
			title: 'Collection Reports',
			img: collectedFee,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			fileName: 'IncomeExpenditure',
			keyData: 'incomeExpenditure',
			title: 'Income & Expenditure',
			img: cashBook,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			fileName: 'ReceiptPayments',
			keyData: 'receiptPayments',
			title: 'Receipts & Payments Accounts',
			img: cashBook,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'subsidiaryRegister',
			title: 'Subsidiary Register',
			img: subsidiaryRegister,
			instituitionType: ['aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'headAccountant', 'cashier', 'superintend', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'subsidiaryRegisterYearWise',
			title: 'New Subsidiary Register',
			img: subsidiaryRegister,
			instituitionType: ['aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'headAccountant', 'cashier', 'superintend', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'newDCB',
			title: 'DCB',
			img: subsidiaryRegister,
			instituitionType: ['aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'cashBook',
			title: 'Cash Books',
			img: cashBook,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'mainAccounts',
			title: 'Main Accounts',
			img: accounts,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'subAccounts',
			title: 'Sub Accounts',
			img: accounts,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'necttosInvoiceManagement',
			title: 'Necttos Invoice Management',
			img: accounts,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},

		{
			classification: 'Accounts',
			keyData: 'cashBankReports',
			title: 'Cash Bank Reciepts',
			img: collectedFee,
			instituitionType: [],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'fdcb',
			title: 'Due Checker P Wise (FDCB)',
			img: collectedFee,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'duesReport',
			title: 'Due Reports',
			img: dues,
			instituitionType: ['selfCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'scholarship',
			title: 'Scholarship',
			img: scholarship,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'feeConcession',
			title: 'Fee Concession',
			img: scholarship,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'numbers',
			title: 'Numbers',
			img: scholarship,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'superintend', 'office', 'principal'],
		},

		{
			classification: 'Accounts',
			keyData: 'bankCash',
			title: 'Bank / Cash',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'reChecker',
			title: 'Re Check Payemnts',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Accounts',
			keyData: 'tutionFeeData',
			title: 'Bulk Student Fee Data',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},

		{
			classification: 'NAAC',
			keyData: 'naacDataCollection',
			title: 'NAAC Questionnair',
			img: feedback,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'NAAC',
			keyData: 'c1',
			title: 'Criteria 1',
			img: file1,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'NAAC',
			keyData: 'c2',
			title: 'Criteria 2',
			img: file2,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'NAAC',
			keyData: 'c3',
			title: 'Criteria 3',
			img: file3,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'NAAC',
			keyData: 'c4',
			title: 'Criteria 4',
			img: file4,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'NAAC',
			keyData: 'c5',
			title: 'Criteria 5',
			img: file5,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'NAAC',
			keyData: 'c6',
			title: 'Criteria 6',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'NAAC',
			keyData: 'c7',
			title: 'Criteria 7',
			img: file7,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},

		{
			classification: 'c1',
			keyData: 'c1_1',
			title: '1.1',
			img: file1,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'c1',
			keyData: 'c1',
			title: '1.1.3',
			img: file2,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'NAAC',
			keyData: 'naac2024',
			title: 'NAAC 2024',
			img: file1,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'c1',
			keyData: 'c1',
			title: '1.2.1',
			img: file3,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'c1',
			keyData: 'c1',
			title: '1.2.2 & 1.2.3',
			img: file4,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'c1',
			keyData: 'c1',
			title: '1.3.2',
			img: file5,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},
		{
			classification: 'c1',
			keyData: 'c1',
			title: '1.3.3',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'iqac', 'teacher'],
		},

		{
			classification: 'c2',
			keyData: 'c2_1',
			title: '2.1',
			img: file1,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2_4',
			title: '2.1.1',
			img: file2,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2_5',
			title: '2.1.2',
			img: file3,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2_9',
			title: '2.1.2 & 2.1.1',
			img: file3,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2_2',
			title: '2.2',
			img: file4,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2',
			title: '2.2.1',
			img: file3,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2_3',
			title: '2.3',
			img: file5,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2_10',
			title: '2.3.3',
			img: file3,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2',
			title: '2.3.2',
			img: file3,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2_6',
			title: '2.4.1',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2_7',
			title: '2.4.2',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2_6',
			title: '2.4.3',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2',
			title: '2.5.1',
			img: file3,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},
		{
			classification: 'c2',
			keyData: 'c2_8',
			title: '2.6.3',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac', 'naac'],
		},

		{
			classification: 'c3',
			keyData: 'c3_1a',
			title: '3.1(a)',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c3_1b',
			title: '3.1(b)',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c2_7',
			title: '3.1.2',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c2_7',
			title: '3.3.1',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c3_2',
			title: '3.2',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c3_1_1',
			title: '3.1.1 & 3.1.3',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c3_2_2',
			title: '3.2.2',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c3_3_2',
			title: '3.3.2',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c3_3_3',
			title: '3.3.3',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c3_4_2',
			title: '3.4.2',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c3_4_3',
			title: '3.4.3 & 3.4.4',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c3_5_1',
			title: '3.5.1',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},
		{
			classification: 'c3',
			keyData: 'c3_5_2',
			title: '3.5.2',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'iqac'],
		},

		{
			classification: 'NIFR',
			keyData: 'NIFR',
			title: 'NIRF',
			img: file6,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'nirf', 'iqac', 'naac'],
		},

		{
			classification: 'IQAC',
			keyData: 'staffProfile',
			title: 'Staff Profile',
			img: staff,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'iqac'],
		},
		{
			classification: 'IQAC',
			keyData: 'teacherProfile',
			title: 'Teacher Profile',
			img: staff,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'iqac'],
		},
		{
			classification: 'IQAC',
			keyData: 'studentProfile',
			title: 'Student Profile',
			img: student,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'iqac'],
		},
		{
			classification: 'IQAC',
			keyData: 'pendingDocument',
			title: 'Pending Documents',
			img: pending,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'iqac'],
		},
		{
			classification: 'IQAC',
			keyData: 'verifiedDocuments',
			title: 'Verified Documents',
			img: verified,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'iqac'],
		},
		{
			classification: 'IQAC',
			keyData: 'masterTimetable',
			title: 'Master Timetable',
			img: master2,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'iqac'],
		},
		{
			classification: 'IQAC',
			keyData: 'subjectAllocation',
			title: 'Subject Allocation',
			img: allocation,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'iqac'],
		},
		{
			classification: 'IQAC',
			keyData: 'attendanceData',
			title: 'Attendance',
			img: atts,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'iqac'],
		},
		{
			classification: 'IQAC',
			keyData: 'feedBackReports',
			title: 'Feed Back Report',
			img: feedback,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'iqac'],
		},

		{
			classification: 'Academics',
			keyData: 'attendanceMonthlyRegister',
			title: 'Attendance Monthly Register',
			img: attendanceRegister,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'masterTimeTables',
			title: 'Master Timetables',
			img: transferCertificate,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'apc',
			title: 'APC',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'subjectWiseAttendance',
			title: 'Subject Wise Attendance',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'classWiseAttendance',
			title: 'Class Wise Attendance',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'rolloutManagement',
			title: 'Rollout Management',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'internal',
			title: 'Internal Form',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'attendanceRegister',
			title: 'Student Intividual Attendance',
			img: applicationForm,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'openCourse',
			title: 'Open Course',
			img: scholarship,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'menteeForm',
			title: 'Mentee Profile PDF',
			img: scholarship,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'subjectBank',
			title: 'Subject Bank',
			img: sb,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'timetable',
			title: 'Time Table',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'departmentMaster',
			title: 'Department Master',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher'],
		},
		{
			classification: 'Academics',
			keyData: 'profac',
			title: 'Profac Monitor',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal'],
		},
		{
			classification: 'Academics',
			keyData: 'accadamicHoliday',
			title: 'Accadamic Holiday Management',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			classification: 'Academics',
			keyData: 'semesterWiseStudentData',
			title: 'SemesterWise Student Data',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			classification: 'Office',
			keyData: 'basicDataVerification',
			title: 'Basic Data Verification',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},

		{
			classification: 'Academics',
			keyData: 'mentorMentee',
			title: 'Mentor Mentee',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			classification: 'Academics',
			keyData: 'masterstockregister',
			title: 'Master Stock Register',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			classification: 'Academics',
			keyData: 'electiveChanger',
			title: 'Elective Changer',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},

		{
			sortKey: '001',
			classification: 'FYUGP',
			keyData: 'subjectRegistry',
			title: 'Registered Courses',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'principal', 'office', 'superintendent', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			sortKey: '002',
			classification: 'FYUGP',
			keyData: 'studentResponds',
			title: 'Student Responses',
			img: 'statistics',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			sortKey: '003',
			classification: 'FYUGP',
			keyData: 'fyugpStatistics',
			title: 'FYUGP Data Analytics',
			img: 'statistics',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			sortKey: '004',
			classification: 'FYUGP',
			keyData: 'standardizationMetrics',
			title: 'FYUGP Standardization Metrics',
			img: 'statistics',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			sortKey: '005',
			classification: 'FYUGP',
			keyData: 'realTimeRanking',
			title: 'FYUGP Live Ranking',
			img: 'applicationForm',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintendent', 'principal', 'clerk', 'nodal', 'teacher', 'staff'],
		},
		{
			sortKey: '006',
			classification: 'FYUGP',
			keyData: 'realTimeAllotment',
			title: 'FYUGP Live Allotment',
			img: 'applicationForm',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintendent', 'principal', 'clerk', 'nodal', 'teacher', 'staff'],
		},
		{
			sortKey: '007',
			classification: 'FYUGP',
			keyData: 'courseSchedule',
			title: 'FYUGP Course Schedule',
			img: 'applicationForm',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'superintendent', 'principal', 'clerk', 'nodal', 'teacher', 'staff'],
		},
		{
			sortKey: '008',
			classification: 'FYUGP',
			keyData: 'allotmentListClassWise',
			title: 'Allotment Report Class Wise',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'principal', 'office', 'superintendent', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			sortKey: '009',
			classification: 'FYUGP',
			keyData: 'fyugpDashBoard',
			title: 'Allotment Dash Board',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'principal', 'office', 'superintendent', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			sortKey: '010',
			classification: 'FYUGP',
			keyData: 'confirmedClassWiseAllotment',
			title: 'Confirmed Class Wise Allotment ',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'principal', 'office', 'superintendent', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			sortKey: '010',
			classification: 'FYUGP',
			keyData: 'confirmedBatchWiseAllotment',
			title: 'Confirmed Batch Wise Allotment ',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'principal', 'office', 'superintendent', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			sortKey: '011',
			classification: 'FYUGP',
			keyData: 'confirmedCourseWiseAllotment',
			title: 'Confirmed Course Wise Allotment',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'principal', 'office', 'superintendent', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			sortKey: '012',
			classification: 'FYUGP',
			keyData: 'sportAdmission',
			title: 'Sport Admission',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'principal', 'office', 'superintendent', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			sortKey: '013',
			classification: 'FYUGP',
			keyData: 'universityUploadList',
			title: 'University Upload List',
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'principal', 'office', 'superintendent', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},

		{
			classification: 'Events',
			keyData: 'cordinatorShipAdmin',
			title: 'Co-ordinator Ship Admin',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			classification: 'Events',
			keyData: 'cordinatorShipForm',
			title: 'Co-ordinator Ship Form',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			classification: 'Events',
			keyData: 'clubCellsAccounts',
			title: 'Club Cells Accounts',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			classification: 'Library',
			keyData: 'opac',
			title: 'OPAC',
			img: opac,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant', 'libraryMember', 'teacher', 'student', 'staff', 'principal'],
		},
		{
			classification: 'Library',
			keyData: 'issueBook',
			title: 'Issue',
			img: issue,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant'],
		},
		{
			classification: 'Library',
			keyData: 'renewBook',
			title: 'Renew',
			img: reniew,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant', 'libraryMember'],
		},
		{
			classification: 'Library',
			keyData: 'returnBook',
			title: 'Return',
			img: returnBook,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant'],
		},
		{
			classification: 'Library',
			keyData: 'activeRegister',
			title: 'Active Register',
			img: activeRegister,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant', 'principal'],
		},
		{
			classification: 'Library',
			keyData: 'members',
			title: 'Members',
			img: members,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant'],
		},
		{
			classification: 'Library',
			keyData: 'master',
			title: 'Master',
			img: master,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},
		{
			classification: 'Academics',
			keyData: 'essentialData',
			title: 'Student Data Management',
			img: statistics,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'principal', 'teacher', 'staff'],
		},
		{
			classification: 'Library',
			keyData: 'lostRegister',
			title: 'Lost register',
			img: lost,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},
		{
			classification: 'Library',
			keyData: 'periodicals',
			title: 'Periodicals',
			img: suscribe,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},
		{
			classification: 'Library',
			keyData: 'periodicalsEntry',
			title: 'Periodicals Entry',
			img: suscribe,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant'],
		},
		{
			classification: 'Library',
			keyData: 'movements',
			title: 'Movement',
			img: movement,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant'],
		},
		{
			classification: 'Library',
			keyData: 'fineRegister',
			title: 'Fine Register',
			img: subsidiaryRegister,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant', 'principal', 'libraryMember'],
		},
		{
			classification: 'Library',
			keyData: 'footPrint',
			title: 'Foot Print',
			img: footprint,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant', 'libraryMember'],
		},
		{
			classification: 'Library',
			keyData: 'addBook',
			title: 'Add Books',
			img: addBook,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},
		{
			classification: 'Library',
			keyData: 'labels',
			title: 'Labels',
			img: labels,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library', 'libraryAssistant'],
		},
		{
			classification: 'Library',
			keyData: 'ddcSubjects',
			title: 'DDC',
			img: ddc,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},
		{
			classification: 'Library',
			keyData: 'holidays',
			title: 'Holiday',
			img: holyday,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},
		{
			classification: 'Library',
			keyData: 'eResources',
			title: 'E-Resources',
			img: holyday,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},
		{
			classification: 'Library',
			keyData: 'libraryStatisticsExport',
			title: 'Export',
			img: exportPng,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},
		{
			classification: 'Library',
			keyData: 'bookRecomentation',
			title: 'Book Recommendation',
			img: holyday,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},
		{
			classification: 'Library',
			keyData: 'invoiceManagement',
			title: 'Invoice Management',
			img: holyday,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},
		{
			classification: 'Library',
			keyData: 'dueRegister',
			title: 'Due Register',
			img: holyday,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'library'],
		},

		{
			classification: 'Election',
			keyData: 'post',
			title: 'Post ',
			img: accounts,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Election',
			keyData: 'nomination',
			title: 'Nomination ',
			img: accounts,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Election',
			keyData: 'counting',
			title: 'Counting ',
			img: accounts,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'cashier', 'office', 'principal'],
		},
		{
			classification: 'Election',
			keyData: 'electoralRoll',
			title: 'Electoral Roll',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'office', 'principal'],
		},

		{
			classification: 'QuestionPaper',
			keyData: 'subjectBank',
			title: 'Subject Bank',
			img: sb,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'director', 'manager', 'pricipal', 'office', 'superintend', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'teacher'],
		},
		{
			classification: 'QuestionPaper',
			keyData: 'questionBankCreator',
			title: 'Question Bank Creator',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			classification: 'QuestionPaper',
			keyData: 'questionBankCreatorVerification',
			title: 'Question Bank Verification',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			classification: 'QuestionPaper',
			keyData: 'questionBankManager',
			title: 'Question Bank Manager',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			classification: 'QuestionPaper',
			keyData: 'questionBank',
			title: 'Question Paper',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			classification: 'QuestionPaper',
			keyData: 'questionPaperCreation',
			title: 'Question Paper Creation',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},

		{
			sortKey: '001',
			classification: 'Examination',
			keyData: 'examInit',
			title: 'Exam Init',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '002',
			classification: 'Examination',
			keyData: 'examNotification',
			title: 'Exam Notification',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '003',
			classification: 'Examination',
			keyData: 'condonation',
			title: 'Condonation',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '004',
			classification: 'Examination',
			keyData: 'examRegistration',
			title: 'Exam Registration',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '005',
			classification: 'Examination',
			keyData: 'timeTableManagement',
			title: 'Time Table Management',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '006',
			classification: 'Examination',
			keyData: 'seatingPlan',
			title: 'Seating Arragement',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '007',
			classification: 'Examination',
			keyData: 'roomArrangement',
			title: 'Room Arrangement',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '008',
			classification: 'Examination',
			keyData: 'invigilationManagement',
			title: 'Invigilation Management',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '009',
			classification: 'Examination',
			keyData: 'halltiketDistribution',
			title: 'Halltiket Distribution',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '011',
			classification: 'Examination',
			keyData: 'roomDocuments',
			title: 'Room Documents Download',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '0111',
			classification: 'Examination',
			keyData: 'falseNumbering',
			title: 'False  Numbering',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '012',
			classification: 'Examination',
			keyData: 'barcodeDownload',
			title: 'Barcode Download',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '0122',
			classification: 'Examination',
			keyData: 'answerSheetBundleManagement',
			title: 'Answer Sheet Bundle Management',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '013',
			classification: 'Examination',
			keyData: 'valuationManagement',
			title: 'Valuation Management',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '014',
			classification: 'Examination',
			keyData: 'resultPublication',
			title: 'Result  Publication',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal'],
		},
		{
			sortKey: '019',
			classification: 'DDFS',
			keyData: 'hierarchyManagement',
			title: 'Hierarchy Management',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'director'],
		},
		{
			sortKey: '019',
			classification: 'DDFS',
			keyData: 'templateManagement',
			title: 'Template Management',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'director'],
		},
		{
			sortKey: '019',
			classification: 'DDFS',
			keyData: 'ddFSDash',
			title: 'DDFS Dashboard',
			img: electoralRoll,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege'],
			allowedUsers: ['admin', 'teacher', 'principal', 'director', 'staff', 'office', 'superintendent', 'headAccountant', 'cashier', 'typist', 'technicalAssistant', 'computerAssistant', 'clerk', 'nodal', 'student'],
		},
		{
			sortKey: '020',
			classification: 'Office',
			keyData: 'dataBank',
			title: 'Individual Data Managemen',
			img: electoralRoll,
			instituitionType: ['necttos'],
			allowedUsers: ['admin', 'staff', 'office'],
		},
		{
			sortKey: '021',
			classification: 'Office',
			keyData: 'activityMonitoring',
			title: 'Activity Monitoring',
			img: electoralRoll,
			instituitionType: ['necttos'],
			allowedUsers: ['admin', 'staff', 'office'],
		},
		{
			sortKey: '021',
			classification: 'Office',
			keyData: 'featureManagement',
			title: 'Feature Management',
			img: subsidiaryRegister,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege', 'necttos'],
			allowedUsers: ['admin', 'principal', 'director'],
		},
		{
			sortKey: '021',
			classification: 'Office',
			keyData: 'formsManagement',
			title: 'Forms Management',
			img: feedback,
			instituitionType: ['selfCollege', 'aidedCollege', 'govtCollege', 'necttos'],
			allowedUsers: ['admin', 'principal', 'director', 'office', 'staff'],
		},

		// { sortKey: "015", classification: "Examination", keyData: "revaluation", title: "Revaluation/Scrutony Management", img: electoralRoll, instituitionType: ["selfCollege", "aidedCollege", "govtCollege"], allowedUsers: ["admin", "teacher", "principal"] },
		// { sortKey: "016", classification: "Examination", keyData: "suplimentory", title: "Suplimentory/Improvement Management", img: electoralRoll, instituitionType: ["selfCollege", "aidedCollege", "govtCollege"], allowedUsers: ["admin", "teacher", "principal"] },
		// { sortKey: "017", classification: "Examination", keyData: "tabulation", title: "Tabulation & Sending University", img: electoralRoll, instituitionType: ["selfCollege", "aidedCollege", "govtCollege"], allowedUsers: ["admin", "teacher", "principal"] },
	];

	if (needFilter) {
		MENU_ITEMS = MENU_ITEMS?.filter((x) => x?.instituitionType?.includes(selectedCollege?.type));
	}

	if (collegeId === 'COL-BB271658898E-4DE0-BC30-B58B89594F80') {
		MENU_ITEMS = MENU_ITEMS.filter((x) => ['feeStructure', 'feesBilling', 'collectioReportsNew', 'tcCc', 'featureManagement'].includes(x.keyData));
	}

	MENU_ITEMS = MENU_ITEMS?.sort((a, b) => {
		if (a?.title > b?.title) return 1;
		if (a?.title < b?.title) return -1;
		return 0;
	});
	return MENU_ITEMS;
};

export const WindowRenderer = ({ windows, setWindows, criteria, setCriteria, verificationWindows, allBookList }) => {
	return (
		<>
			{windows.collegeVerifcation && <CollegeVerification onClose={() => setWindows({ ...windows, collegeVerifcation: false })} />}
			{windows.bugHandler && <BugHandler onClose={() => setWindows({ ...windows, bugHandler: false })} />}
			{windows.TaskTracker && <TaskTracker onClose={() => setWindows({ ...windows, TaskTracker: false })} />}
			{windows.CareerView && <CareerView onClose={() => setWindows({ ...windows, CareerView: false })} />}
			{windows.Documentation && <Documentation onClose={() => setWindows({ ...windows, Documentation: false })} />}
			{windows.Circular && <Circular onClose={() => setWindows({ ...windows, Circular: false })} />}

			{windows.feedBackReports && <FeedBackDashBoard onClose={() => setWindows({ ...windows, feedBackReports: false })} />}
			{windows.naacDataCollection && <NaacDataCollection onClose={() => setWindows({ ...windows, naacDataCollection: false })} />}
			{windows.openCourse && <OpenCourse onClose={() => setWindows({ ...windows, openCourse: false })} />}
			{windows.teacherProfile && <TeacherProfile onClose={() => setWindows({ ...windows, teacherProfile: false })} />}
			{windows.studentProfile && <StudentProfile onClose={() => setWindows({ ...windows, studentProfile: false })} />}
			{windows.staffProfile && <StaffProfile onClose={() => setWindows({ ...windows, staffProfile: false })} />}
			{windows.hierarchy && <RoleManagements onClose={() => setWindows({ ...windows, hierarchy: false })} />}
			{windows.attendanceRegister && <Attendance onClose={() => setWindows({ ...windows, attendanceRegister: false })} />}
			{windows.attendanceMonthlyRegister && <AttendanceMonthly onClose={() => setWindows({ ...windows, attendanceMonthlyRegister: false })} />}
			{windows.feeStructure && <FeeStructure onClose={() => setWindows({ ...windows, feeStructure: false })} />}
			{windows.issueBook && <IssueBook onClose={() => setWindows({ ...windows, issueBook: false })} />}
			{windows.c2 && <C2 onClose={() => setWindows({ ...windows, c2: false })} />}
			{windows.profac && <ProFacMonitor onClose={() => setWindows({ ...windows, profac: false })} />}
			{windows?.deleteUser && <DeleteUser onClose={() => setWindows({ ...windows, deleteUser: false })} />}
			{windows.invoiceManagement && (
				<InvoiceManagement
					onClose={() => {
						closeAnimation();
						setTimeout(() => setWindows({ ...windows, invoiceManagement: false }), 500);
					}}
				/>
			)}
			{windows.lostRegister && (
				<LoastRegister
					onClose={() => {
						closeAnimation();
						setTimeout(() => setWindows({ ...windows, lostRegister: false }), 500);
					}}
				/>
			)}
			{windows.hungerFreeCampus && (
				<HungryFreeCampus
					onClose={() => {
						closeAnimation();
						setTimeout(() => setWindows({ ...windows, hungerFreeCampus: false }), 500);
					}}
				/>
			)}
			{windows.renewBook && <RenewBook onClose={() => setWindows({ ...windows, renewBook: false })} />}
			{windows.activeRegister && <ActiveRegister onClose={() => setWindows({ ...windows, activeRegister: false })} />}
			{windows.returnBook && <ReturnBook onClose={() => setWindows({ ...windows, returnBook: false })} />}
			{windows.addBook && (
				<ModalWrapper>
					<AddBook
						onCloseModal={() => setWindows({ ...windows, addBook: false })}
						allBookList={allBookList}
						onSuccess={() => {
							setWindows({ ...windows, addBook: false });
						}}
					/>
				</ModalWrapper>
			)}
			{windows.opac && <Opac onClose={() => setWindows({ ...windows, opac: false })} />}
			{windows.master && <Master onClose={() => setWindows({ ...windows, master: false })} />}
			{windows.members && <Members onClose={() => setWindows({ ...windows, members: false })} />}
			{windows.movements && <Movements onClose={() => setWindows({ ...windows, movements: false })} />}
			{windows.labels && <Labels onClose={() => setWindows({ ...windows, labels: false })} />}
			{windows.ddcSubjects && <DDCSubjects onClose={() => setWindows({ ...windows, ddcSubjects: false })} />}
			{windows.holidays && <Holidays onClose={() => setWindows({ ...windows, holidays: false })} />}
			{windows.eResources && <EResources onClose={() => setWindows({ ...windows, eResources: false })} />}
			{windows.periodicals && <Periodicals onClose={() => setWindows({ ...windows, periodicals: false })} />}
			{windows.periodicalsEntry && <PeriodicalsEntry onClose={() => setWindows({ ...windows, periodicalsEntry: false })} />}
			{windows.fineRegister && <FineRegister onClose={() => setWindows({ ...windows, fineRegister: false })} />}
			{windows.footPrint && <FootPrint onClose={() => setWindows({ ...windows, footPrint: false })} />}
			{windows.libraryStatisticsExport && <LibraryStatisticsExport onClose={() => setWindows({ ...windows, libraryStatisticsExport: false })} />}
			{windows.rollView && <RollView onClose={() => setWindows({ ...windows, rollView: false })} />}
			{windows.nameSlip && <NameSlip onClose={() => setWindows({ ...windows, nameSlip: false })} />}
			{windows.newNameSlip && <NewNameSlip onClose={() => setWindows({ ...windows, newNameSlip: false })} />}
			{windows.strengthDetails && <StrengthDetails onClose={() => setWindows({ ...windows, strengthDetails: false })} />}
			{windows.catogoryList && <CatogoryListData onClose={() => setWindows({ ...windows, catogoryList: false })} />}
			{windows.electoralRoll && <ElectoralRoll onClose={() => setWindows({ ...windows, electoralRoll: false })} />}
			{windows.menteeForm && <MenteePDF onClose={() => setWindows({ ...windows, menteeForm: false })} />}
			{windows.tcCc && <TransferSertificateCC onClose={() => setWindows({ ...windows, tcCc: false })} />}
			{windows.masterTimeTables && <MasterTimeTables onClose={() => setWindows({ ...windows, masterTimeTables: false })} />}
			{windows.statistics && <Statistics onClose={() => setWindows({ ...windows, statistics: false })} />}
			{windows.internalAssessment && <InternalAssessment onClose={() => setWindows({ ...windows, internalAssessment: false })} />}
			{windows.newRolloutManagement && <NewRolloutManagement onClose={() => setWindows({ ...windows, newRolloutManagement: false })} />}
			{windows.leaveReports && <LeaveReports onClose={() => setWindows({ ...windows, leaveReports: false })} />}
			{windows.releaving && <Releaving onClose={() => setWindows({ ...windows, releaving: false })} />}
			{windows.newDCB && <NEWDCB onClose={() => setWindows({ ...windows, newDCB: false })} />}
			{windows.newDFCR && <DFCR onClose={() => setWindows({ ...windows, newDFCR: false })} />}
			{windows.subsidiaryRegisterYearWise && <SubsidiaryRegisterYearWise onClose={() => setWindows({ ...windows, subsidiaryRegisterYearWise: false })} />}

			{windows.c1 && <C1 onClose={() => setWindows({ ...windows, c1: false })} />}
			{windows.c3 && <C3 onClose={() => setWindows({ ...windows, c3: false })} />}

			{windows.mentorMentee && (
				<MentorMentee
					onClose={() => {
						closeAnimation();
						setTimeout(() => setWindows({ ...windows, mentorMentee: false }), 500);
					}}
				/>
			)}

			{windows.mainAccounts && <MainAccounts onClose={() => setWindows({ ...windows, mainAccounts: false })} />}
			{windows.numbers && <Numbers onClose={() => setWindows({ ...windows, numbers: false })} />}
			{windows.subAccounts && <SubAccounts onClose={() => setWindows({ ...windows, subAccounts: false })} />}
			{windows.cashBook && <CashBook onClose={() => setWindows({ ...windows, cashBook: false })} />}
			{windows.incomeExpenditure && <IncomeExpenditure onClose={() => setWindows({ ...windows, incomeExpenditure: false })} />}
			{windows.receiptPayments && <RecieptsPayments onClose={() => setWindows({ ...windows, receiptPayments: false })} />}
			{windows.dayBook && <DayBook2 onClose={() => setWindows({ ...windows, dayBook: false })} />}
			{windows.collectionReports && <CollectionReports onClose={() => setWindows({ ...windows, collectionReports: false })} />}
			{windows.collectionReportsAMC && <CollectionReportsAMC onClose={() => setWindows({ ...windows, collectionReportsAMC: false })} />}
			{windows.collectioReportsNew && <CollectioReportsNew onClose={() => setWindows({ ...windows, collectioReportsNew: false })} />}
			{windows.cashBankReports && <CashBankReports onClose={() => setWindows({ ...windows, cashBankReports: false })} />}
			{windows.fdcb && <FDCB onClose={() => setWindows({ ...windows, fdcb: false })} />}
			{windows.duesReport && <DuesReport onClose={() => setWindows({ ...windows, duesReport: false })} />}
			{windows.scholarship && <Scholarship onClose={() => setWindows({ ...windows, scholarship: false })} />}
			{windows.feeConcession && <FeeConcession onClose={() => setWindows({ ...windows, feeConcession: false })} />}
			{windows.newProfile && <NewProfile onClose={() => setWindows({ ...windows, newProfile: false })} setWindows={setWindows} windows={windows} />}
			{windows.earnLeaveCalculator && <EarnLeaveCalculator onClose={() => setWindows({ ...windows, earnLeaveCalculator: false })} />}
			{windows.instanceFeeCollection && <InstanceFeeCollection onClose={() => setWindows({ ...windows, instanceFeeCollection: false })} />}
			{windows.essentialData && <BEDStudent onClose={() => setWindows({ ...windows, essentialData: false })} />}
			{windows.basicDataVerification && <BasicDataVerification onClose={() => setWindows({ ...windows, basicDataVerification: false })} />}
			{windows.tutionFeeData && <BulkFeeData onClose={() => setWindows({ ...windows, tutionFeeData: false })} />}

			{windows.apc && (
				<ModalWrapper>
					<APC onClose={() => setWindows({ ...windows, apc: false })} />
				</ModalWrapper>
			)}
			{windows.subjectWiseAttendance && (
				<ModalWrapper>
					<SubjectWiseAttendance onClose={() => setWindows({ ...windows, subjectWiseAttendance: false })} />
				</ModalWrapper>
			)}
			{windows.classWiseAttendance && (
				<ModalWrapper>
					<ClassWiseAttendance onClose={() => setWindows({ ...windows, classWiseAttendance: false })} />
				</ModalWrapper>
			)}
			{windows?.subjectBank && (
				<ModalWrapper>
					<SubjectBank onClose={() => setWindows({ ...windows, subjectBank: false })} />
				</ModalWrapper>
			)}

			{windows.internal && (
				<ModalWrapper>
					<Internal onClose={() => setWindows({ ...windows, internal: false })} />
				</ModalWrapper>
			)}
			{windows.idCardPrinting && (
				<ModalWrapper>
					<IdCardPrinting onClose={() => setWindows({ ...windows, idCardPrinting: false })} />
				</ModalWrapper>
			)}
			{windows.createAccount && (
				<ModalWrapper>
					<CreateAccount onClose={() => setWindows({ ...windows, createAccount: false })} />
				</ModalWrapper>
			)}
			{windows.departmentVerification && (
				<ModalWrapper>
					<DepartmentVery onClose={() => setWindows({ ...windows, departmentVerification: false })} />
				</ModalWrapper>
			)}

			{windows.nodalVerification && (
				<ModalWrapper>
					<AdmissionProcessingDashBoard isTemp={false} onClose={() => setWindows({ ...windows, nodalVerification: false })} />
				</ModalWrapper>
			)}
			{windows.nodalVerificationTemp && (
				<ModalWrapper>
					<AdmissionProcessingDashBoard isTemp={true} onClose={() => setWindows({ ...windows, nodalVerificationTemp: false })} />
				</ModalWrapper>
			)}
			{windows.ptaVerification && (
				<ModalWrapper>
					<PTA setItemsData={setWindows} itemsData={windows} onClose={() => setWindows({ ...windows, ptaVerification: false })} />
				</ModalWrapper>
			)}
			{windows.principalVerification && (
				<ModalWrapper>
					<Principal checkAdmin={verificationWindows?.giveAdmissionNumber} onClose={() => setWindows({ ...windows, principalVerification: false })} />
				</ModalWrapper>
			)}
			{windows.officeVerification && (
				<ModalWrapper>
					<Office checkAdmin={verificationWindows?.giveAdmissionNumber} onClose={() => setWindows({ ...windows, officeVerification: false })} />
				</ModalWrapper>
			)}
			{windows.feesVerification && (
				<ModalWrapper>
					<Fees setItemsData={setWindows} itemsData={windows} checkAdmin={verificationWindows?.giveAdmissionNumber} studentId={windows?.studentId} onClose={() => setWindows({ ...windows, feesVerification: false })} />
				</ModalWrapper>
			)}
			{windows.grandVerification && (
				<ModalWrapper>
					<EGrantz onClose={() => setWindows({ ...windows, grandVerification: false })} />
				</ModalWrapper>
			)}
			{windows.eGrantManagement && (
				<ModalWrapper>
					<EGrantManagement onClose={() => setWindows({ ...windows, eGrantManagement: false })} />
				</ModalWrapper>
			)}

			{windows.universityUploading && (
				<ModalWrapper>
					<University onClose={() => setWindows({ ...windows, universityUploading: false })} />
				</ModalWrapper>
			)}
			{windows.dashBoard && (
				<ModalWrapper>
					<DashBoard onClose={() => setWindows({ ...windows, dashBoard: false })} />
				</ModalWrapper>
			)}
			{windows.controller && (
				<ModalWrapper>
					<Controller onClose={() => setWindows({ ...windows, controller: false })} />
				</ModalWrapper>
			)}
			{windows.splitups && (
				<ModalWrapper>
					<Splitups onClose={() => setWindows({ ...windows, splitups: false })} />
				</ModalWrapper>
			)}
			{windows.feesBilling && (
				<ModalWrapper>
					<FeeBilling setItemsData={setWindows} keyDataIsStaff={windows?.keyDataIsStaff} itemsData={windows} studentId={windows?.studentId} onClose={() => setWindows({ ...windows, feesBilling: false })} />
				</ModalWrapper>
			)}
			{windows.epos && (
				<ModalWrapper>
					<EPosMirgration onClose={() => setWindows({ ...windows, epos: false })} />
				</ModalWrapper>
			)}
			{windows.rankList && (
				<ModalWrapper>
					<RankList onClose={() => setWindows({ ...windows, rankList: false })} />
				</ModalWrapper>
			)}
			{windows.post && (
				<ModalWrapper>
					<PostElection onClose={() => setWindows({ ...windows, post: false })} />
				</ModalWrapper>
			)}
			{criteria?.c1_1 && (
				<ModalWrapper>
					<C1_1 onClose={() => setCriteria({ ...criteria, c1_1: false })} />
				</ModalWrapper>
			)}

			{criteria?.c2_1 && (
				<C2_1
					onClose={() => {
						closeAnimation();
						setTimeout(() => {
							setCriteria({ ...criteria, c2_1: false });
						}, 250);
					}}
				/>
			)}
			{criteria?.c2_2 && (
				<C2_2
					onClose={() => {
						closeAnimation();
						setTimeout(() => {
							setCriteria({ ...criteria, c2_2: false });
						}, 1000);
					}}
				/>
			)}
			{criteria?.c2_3 && (
				<C2_3
					onClose={() => {
						closeAnimation();
						setTimeout(() => {
							setCriteria({ ...criteria, c2_3: false });
						}, 1000);
					}}
				/>
			)}
			{criteria?.c2_4 && (
				<C2_4
					onClose={() => {
						closeAnimation();
						setTimeout(() => {
							setCriteria({ ...criteria, c2_4: false });
						}, 1000);
					}}
				/>
			)}
			{criteria?.c2_5 && (
				<C2_5
					onClose={() => {
						closeAnimation();

						setTimeout(() => {
							setCriteria({ ...criteria, c2_5: false });
						}, 1000);
					}}
				/>
			)}
			{criteria?.c2_6 && (
				<C2_6
					onClose={() => {
						closeAnimation();
						setTimeout(() => {
							setCriteria({ ...criteria, c2_6: false });
						}, 1000);
					}}
				/>
			)}
			{criteria?.c2_7 && (
				<C2_7
					onClose={() => {
						closeAnimation();
						setTimeout(() => {
							setCriteria({ ...criteria, c2_7: false });
						}, 1000);
					}}
				/>
			)}
			{criteria?.c2_8 && (
				<C2_8
					onClose={() => {
						closeAnimation();
						setTimeout(() => {
							setCriteria({ ...criteria, c2_8: false });
						}, 1000);
					}}
				/>
			)}
			{criteria?.c2_9 && (
				<C2_9
					onClose={() => {
						closeAnimation();
						setTimeout(() => {
							setCriteria({ ...criteria, c2_9: false });
						}, 1000);
					}}
				/>
			)}
			{criteria?.c2_10 && (
				<ModalWrapper>
					<C2_10
						onClose={() => {
							closeAnimation();
							setTimeout(() => {
								setCriteria({ ...criteria, c2_10: false });
							}, 1000);
						}}
					/>
				</ModalWrapper>
			)}

			{criteria?.c3_1a && (
				<ModalWrapper>
					<C3_1a onClose={() => setCriteria({ ...criteria, c3_1a: false })} />
				</ModalWrapper>
			)}
			{criteria?.c3_1b && (
				<ModalWrapper>
					<C3_1b onClose={() => setCriteria({ ...criteria, c3_1b: false })} />
				</ModalWrapper>
			)}
			{criteria?.c3_1_1 && (
				<ModalWrapper>
					<C3_1_1 onClose={() => setCriteria({ ...criteria, c3_1_1: false })} />
				</ModalWrapper>
			)}
			{criteria?.c3_2_2 && (
				<ModalWrapper>
					<C3_2_2 onClose={() => setCriteria({ ...criteria, c3_2_2: false })} />
				</ModalWrapper>
			)}
			{criteria?.c3_3_2 && (
				<ModalWrapper>
					<C3_3_2 onClose={() => setCriteria({ ...criteria, c3_3_2: false })} />
				</ModalWrapper>
			)}
			{criteria?.c3_3_3 && (
				<ModalWrapper>
					<C3_3_3 onClose={() => setCriteria({ ...criteria, c3_3_3: false })} />
				</ModalWrapper>
			)}
			{criteria?.c3_4_2 && (
				<ModalWrapper>
					<C3_4_2 onClose={() => setCriteria({ ...criteria, c3_4_2: false })} />
				</ModalWrapper>
			)}
			{criteria?.c3_4_3 && (
				<ModalWrapper>
					<C3_4_3 onClose={() => setCriteria({ ...criteria, c3_4_3: false })} />
				</ModalWrapper>
			)}
			{criteria?.c3_5_1 && (
				<ModalWrapper>
					<C3_5_1 onClose={() => setCriteria({ ...criteria, c3_5_1: false })} />
				</ModalWrapper>
			)}
			{criteria?.c3_5_2 && (
				<ModalWrapper>
					<C3_5_2 onClose={() => setCriteria({ ...criteria, c3_5_2: false })} />
				</ModalWrapper>
			)}
			{windows?.NIFR && (
				<ModalWrapper>
					<NIFR onClose={() => setWindows({ ...windows, NIFR: false })} />
				</ModalWrapper>
			)}
			{windows?.masterTable && (
				// <ModalWrapper>
				<AdmissionRegister3 onClose={() => setWindows({ ...windows, masterTable: false })} />
				// </ModalWrapper>
			)}
			{windows?.timetable && (
				<ModalWrapper>
					<TimeShedulePage onClose={() => setWindows({ ...windows, timetable: false })} />
				</ModalWrapper>
			)}
			{windows?.addUser && <AddUserPage onClose={() => setWindows({ ...windows, addUser: false })} />}

			{windows?.supperVission && (
				<ModalWrapper>
					<SupperVision onClose={() => setWindows({ ...windows, supperVission: false })} />
				</ModalWrapper>
			)}
			{windows?.departmentMaster && (
				<ModalWrapper>
					<DepartmentMaster onClose={() => setWindows({ ...windows, departmentMaster: false })} />
				</ModalWrapper>
			)}
			{windows.bookRecomentation && <BookRecomentation onClose={() => setWindows({ ...windows, bookRecomentation: false })} />}
			{windows.bankCash && <BankCash onClose={() => setWindows({ ...windows, bankCash: false })} />}
			{windows.accadamicHoliday && <AccademicHoliday onClose={() => setWindows({ ...windows, accadamicHoliday: false })} />}
			{windows.semesterWiseStudentData && <SemesterWiseStudentData onClose={() => setWindows({ ...windows, semesterWiseStudentData: false })} />}
			{windows.masterstockregister && <MasterStockRegister onClose={() => setWindows({ ...windows, masterstockregister: false })} />}
			{windows.questionBankCreator && <QuestionBankCreator onClose={() => setWindows({ ...windows, questionBankCreator: false })} />}
			{windows.questionBankCreatorVerification && <QuestionBankCreatorVerification onClose={() => setWindows({ ...windows, questionBankCreatorVerification: false })} />}

			{windows.questionPaperCreation && <QuestionPaper onClose={() => setWindows({ ...windows, questionPaperCreation: false })} />}
			{windows.examInit && <ExamInit onClose={() => setWindows({ ...windows, examInit: false })} />}
			{windows.answerSheetBundleManagement && <AnswerSheetBundleManagement onClose={() => setWindows({ ...windows, answerSheetBundleManagement: false })} />}
			{windows.examNotification && <ExamNotification onClose={() => setWindows({ ...windows, examNotification: false })} />}
			{windows.condonation && <Condonation onClose={() => setWindows({ ...windows, condonation: false })} />}
			{windows.electiveChanger && <ElectiveChanger onClose={() => setWindows({ ...windows, electiveChanger: false })} />}
			{windows.questionBankManager && <QuetionBankManager onClose={() => setWindows({ ...windows, questionBankManager: false })} />}
			{windows.analytics && <Analytics onClose={() => setWindows({ ...windows, analytics: false })} />}
			{windows.applicationRecieved && <ApplicationRecieved onClose={() => setWindows({ ...windows, applicationRecieved: false })} />}
			{windows.enquryForm && <EnquriyForm onClose={() => setWindows({ ...windows, enquryForm: false })} />}
			{windows.pyementWaitingSubmition && <PyementWaitingSubmition onClose={() => setWindows({ ...windows, pyementWaitingSubmition: false })} />}
			{windows.cordinatorShipAdmin && <CordinatorShipAdmin onClose={() => setWindows({ ...windows, cordinatorShipAdmin: false })} />}
			{windows.cordinatorShipForm && <CordinatorShipForm onClose={() => setWindows({ ...windows, cordinatorShipForm: false })} />}
			{windows.clubCellsAccounts && <ClubCellsAccounts onClose={() => setWindows({ ...windows, clubCellsAccounts: false })} />}
			{windows.courseManagement && <CourseManagement onClose={() => setWindows({ ...windows, courseManagement: false })} />}
			{windows.applicationStated && <ApplicationStarted onClose={() => setWindows({ ...windows, applicationStated: false })} />}
			{windows.insertUsers && <InsertData onClose={() => setWindows({ ...windows, insertUsers: false })} />}
			{windows.updateUsers && <UpdateData onClose={() => setWindows({ ...windows, updateUsers: false })} />}
			{windows.rankListAuto && <AllotmentList onClose={() => setWindows({ ...windows, rankListAuto: false })} />}
			{windows.rankListRules && <RankListRules onClose={() => setWindows({ ...windows, rankListRules: false })} />}
			{windows.reChecker && <RecheckPayments onClose={() => setWindows({ ...windows, reChecker: false })} />}
			{windows.indexMarkListed && <CourseWiseRankList onClose={() => setWindows({ ...windows, indexMarkListed: false })} />}
			{windows.seatReservation && <SeatReservationDetails onClose={() => setWindows({ ...windows, seatReservation: false })} />}
			{windows.priorityChanger && <PriorityChanger onClose={() => setWindows({ ...windows, priorityChanger: false })} />}
			{windows.certificate && <Certificate onClose={() => setWindows({ ...windows, certificate: false })} />}
			{windows.dueRegister && <DueRegister onClose={() => setWindows({ ...windows, dueRegister: false })} />}
			{windows.subjectRegistry && <SubjectRegistry onClose={() => setWindows({ ...windows, subjectRegistry: false })} />}
			{windows.admissionRegister && <AdmissionRegister3 onClose={() => setWindows({ ...windows, admissionRegister: false })} />}
			{windows.masterTable2 && <DashPage onClose={() => setWindows({ ...windows, masterTable2: false })} />}
			{windows.photoVerification && <PhotoVerification onClose={() => setWindows({ ...windows, photoVerification: false })} />}
			{windows.studentResponds && <StudentResponds onClose={() => setWindows({ ...windows, studentResponds: false })} />}
			{windows.accountActiveFirebase && <AccountActiveFirebase onClose={() => setWindows({ ...windows, accountActiveFirebase: false })} />}
			{windows.photoDownload && <PhotoDownloader onClose={() => setWindows({ ...windows, photoDownload: false })} />}
			{windows.rollNumberDistributer && <Numbering onClose={() => setWindows({ ...windows, rollNumberDistributer: false })} />}
			{windows.examRegistration && <ExamRegistration onClose={() => setWindows({ ...windows, examRegistration: false })} />}
			{windows.timeTableManagement && <TimeTableManagement onClose={() => setWindows({ ...windows, timeTableManagement: false })} />}
			{windows.seatingPlan && <SeatingPlan onClose={() => setWindows({ ...windows, seatingPlan: false })} />}
			{windows.roomArrangement && <RoomArrangement onClose={() => setWindows({ ...windows, roomArrangement: false })} />}
			{windows.invigilationManagement && <InvigilationManagement onClose={() => setWindows({ ...windows, invigilationManagement: false })} />}
			{windows.halltiketDistribution && <HalltiketDistribution onClose={() => setWindows({ ...windows, halltiketDistribution: false })} />}
			{windows.roomDocuments && <RoomDocuments onClose={() => setWindows({ ...windows, roomDocuments: false })} />}
			{windows.barcodeDownload && <BarcodeDownload onClose={() => setWindows({ ...windows, barcodeDownload: false })} />}
			{windows.valuationManagement && <ValuationManagement onClose={() => setWindows({ ...windows, valuationManagement: false })} />}
			{windows.resultPublication && <ResultPublication onClose={() => setWindows({ ...windows, resultPublication: false })} />}
			{windows.falseNumbering && <FalseNumbering onClose={() => setWindows({ ...windows, falseNumbering: false })} />}
			{windows.realTimeAllotment && <RealTimeAllotment onClose={() => setWindows({ ...windows, realTimeAllotment: false })} />}
			{windows.allotmentListClassWise && <StudentsAllotmentClassWise onClose={() => setWindows({ ...windows, allotmentListClassWise: false })} />}
			{windows.realTimeRanking && <RealTimeRanking onClose={() => setWindows({ ...windows, realTimeRanking: false })} />}
			{windows.dataLoader && <DataLoader onClose={() => setWindows({ ...windows, dataLoader: false })} />}
			{windows.fyugpDashBoard && <FYUGPDashBoard onClose={() => setWindows({ ...windows, fyugpDashBoard: false })} />}
			{windows.confirmedClassWiseAllotment && <ConfirmedClassWiseAllotment onClose={() => setWindows({ ...windows, confirmedClassWiseAllotment: false })} />}
			{windows.confirmedBatchWiseAllotment && <ConfirmedBatchWiseAllotment onClose={() => setWindows({ ...windows, confirmedBatchWiseAllotment: false })} />}
			{windows.confirmedCourseWiseAllotment && <ConfirmedCourseWiseAllotment onClose={() => setWindows({ ...windows, confirmedCourseWiseAllotment: false })} />}
			{windows.courseSchedule && <SubjectAllocationAuto onClose={() => setWindows({ ...windows, courseSchedule: false })} />}
			{windows.sportAdmission && <SportAdmission onClose={() => setWindows({ ...windows, sportAdmission: false })} />}
			{windows.universityUploadList && <UniversityUploadList onClose={() => setWindows({ ...windows, universityUploadList: false })} />}
			{windows.tagOrder && <TagOrder onClose={() => setWindows({ ...windows, tagOrder: false })} />}
			{windows.attendanceCorrectionBulk && <AttendanceCorrectionBulk onClose={() => setWindows({ ...windows, attendanceCorrectionBulk: false })} />}
			{windows.newTransferCertificate && <NewTransferCertificate onClose={() => setWindows({ ...windows, newTransferCertificate: false })} />}
			{windows.TransferCertificate && <TransferCertificate onClose={() => setWindows({ ...windows, TransferCertificate: false })} />}
			{windows.dataManagementSystem && <DataManagementSystem onClose={() => setWindows({ ...windows, dataManagementSystem: false })} />}
			{windows.naac2024 && <NAAC2024 onClose={() => setWindows({ ...windows, naac2024: false })} />}
			{windows.necttosInvoiceManagement && <NecttosInvoiceManagement onClose={() => setWindows({ ...windows, necttosInvoiceManagement: false })} />}
			{windows.hierarchyManagement && <HierarchyManagemant onClose={() => setWindows({ ...windows, hierarchyManagement: false })} />}
			{windows.templateManagement && <TemplateManagement onClose={() => setWindows({ ...windows, templateManagement: false })} />}
			{windows.ddFSDash && <DDFSDash onClose={() => setWindows({ ...windows, ddFSDash: false })} />}
			{windows.dataBank && <DataBank onClose={() => setWindows({ ...windows, dataBank: false })} />}
			{windows.settings && <SettingsPage onClose={() => setWindows({ ...windows, settings: false })} />}
			{windows.activityMonitoring && <ActivityMonitoring onClose={() => setWindows({ ...windows, activityMonitoring: false })} />}
			{windows.backup && <BackUp onClose={() => setWindows({ ...windows, backup: false })} />}
			{windows.featureManagement && <FeatureManagement onClose={() => setWindows({ ...windows, featureManagement: false })} />}
			{windows.formsManagement && <FormsManagement onClose={() => setWindows({ ...windows, formsManagement: false })} />}
			{windows.admissionControlCenter && <AdmissionControlCenter isTemp={false} onClose={() => setWindows({ ...windows, admissionControlCenter: false })} />}
			{windows.websiteControlCenter && <WebsiteControlCenter isTemp={false} onClose={() => setWindows({ ...windows, websiteControlCenter: false })} />}
			{windows.LearningManagementSystem && <LearningManagementSystem isTemp={false} onClose={() => setWindows({ ...windows, LearningManagementSystem: false })} />}


			{windows.Busconcession && <Busconcession isTemp={false} onClose={() => setWindows({ ...windows, Busconcession: false })} />}

		</>
	);
};
